<template>
    <div v-if="kind === ENTITY_KIND.PARTNER" class="access-chips">
        <template v-if="users.length || foreignCount">
            <span class="access-chips__label">Агентства:</span>
            <button
                v-for="user in shownUsers"
                :key="user.id"
                type="button"
                class="access-chip access-chip--agency"
                :title="`Открыть пользователей партнёра (${user.email})`"
                @click="emit('open-users')"
            >{{ user.email }}</button>
            <span v-if="restCount > 0" class="access-chip access-chip--more" :title="restTitle">+{{ restCount }}</span>
        </template>
        <span v-else class="access-chips__muted">Нет агентств с доступом</span>
    </div>

    <button
        v-else-if="users.length"
        type="button"
        class="access-chip access-chip--clients"
        :title="clientsTitle"
        @click="emit('open-users')"
    >Клиенты: {{ users.length }}</button>
</template>

<script setup>
import { computed } from 'vue';
import { ENTITY_KIND } from '../../../constants/structure';

const MAX_SHOWN = 2;

const props = defineProps({
    kind: { type: String, required: true, validator: value => [ENTITY_KIND.PARTNER, ENTITY_KIND.ADVERTISER].includes(value) },
    users: { type: Array, required: true },
    /** Сколько всего пользователей с доступом по данным сервера — включая тех, кто вне зоны актора. */
    totalCount: { type: Number, default: null },
});

const emit = defineEmits(['open-users']);

const shownUsers = computed(() => props.users.slice(0, MAX_SHOWN));

const foreignCount = computed(() => Math.max(0, (props.totalCount ?? props.users.length) - props.users.length));

const restCount = computed(() => props.users.length - shownUsers.value.length + foreignCount.value);

const restTitle = computed(() => {
    const lines = props.users.slice(MAX_SHOWN).map(user => user.email);
    if (foreignCount.value > 0) lines.push(`и ещё ${foreignCount.value} вне вашей зоны`);
    return lines.join('\n');
});

const clientsTitle = computed(() => `${props.users.map(user => user.email).join('\n')}\n\nОткрыть пользователей`);
</script>

<style scoped lang="scss">
@use '../../../../scss/pages/admin/admin-tokens' as *;

.access-chips {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: $spacing-xs;
    min-width: 0;
}

.access-chips__label {
    margin-right: 2px;
    font-size: $font-size-xs;
    color: $admin-text-muted;
}

.access-chips__muted {
    font-size: $font-size-xs;
    color: $admin-text-light;
}

.access-chip {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 2px $spacing-sm;
    border: 1px solid $admin-border-color;
    border-radius: 999px;
    background: $admin-bg-secondary;
    font-size: $font-size-xs;
    color: $admin-text-secondary;

    &--agency,
    &--clients {
        cursor: pointer;

        &:hover { text-decoration: underline; }
    }

    &--agency { border-color: #c7d2fe; background: #eef2ff; color: #3730a3; }
    &--clients { border-color: #fbcfe8; background: #fdf2f8; color: #9d174d; }
    &--more { cursor: help; font-weight: 600; }
}
</style>
